import {
  timerRefreshInterval,
  videoPlaybackRate,
} from "../../video-player-integration/video-player";

/**
 * To support features like extended AD, we need to be able to determine whether the playhead on
 * some timeline has reached a certain timestamp of interest. For example, extended AD will look
 * for "pause points" in a video's timeline and "play points" in an audio file's timeline.
 *
 * We are not observing the playhead's position continuously; it is updating on some interval. So
 * we need to solve the problem of "has the playhead reached a given position" using intervals. To
 * do this, we are going to chunk the timeline into segments that have a width such that each update
 * interval will occur in one segment. It's important to note that this depends on both the length
 * of the update interval AND the playback speed. Each of these intervals will be indexed so we can
 * identify them.
 */
export function getTimelineSegmentIndex(timestampMS: number): number {
  return Math.floor(
    Math.round(timestampMS) /
      timerRefreshInterval.value /
      videoPlaybackRate.value
  );
}
